@if (donationItems) {
  <div class="preview-item margin-0">
    @if (label) {
      <label>{{ label }}</label>
    }
    <p>{{ donationItems }}</p>
  </div>
}
